import { render, staticRenderFns } from "./UniversalFeed.vue?vue&type=template&id=bd96dbfa"
import script from "./UniversalFeed.vue?vue&type=script&lang=js"
export * from "./UniversalFeed.vue?vue&type=script&lang=js"
import style0 from "./UniversalFeed.vue?vue&type=style&index=0&id=bd96dbfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports